import { Pipe, PipeTransform } from '@angular/core';
import { Group } from '../models/group';

@Pipe({ name: 'groupBy' })
export class GroupByPipe implements PipeTransform {
    transform(value: Array<any>, field: string, expanded: boolean): Array<Group> {
        const groupedObj = value.reduce((prev, cur) => {
            if (!prev[cur[field]]) {
                prev[cur[field]] = [cur];
            } else {
                prev[cur[field]].push(cur);
            }
            return prev;
        }, {});
        if (expanded === undefined || expanded === null) {
            expanded = true;
        }
        const array = Object.keys(groupedObj).map(key => ({ key, value: groupedObj[key], expanded: expanded }));
        return array.sort((a: any, b: any) => {
            if (a['key'] < b['key']) {
                return -1;
            } else if (a['key'] > b['key']) {
                return 1;
            } else {
                return 0;
            }
        });

    }
}
